import moment from 'moment';
import HelperMixin from '../../Shared/HelperMixin.vue';
import PaginationHelper from '../../Shared/PaginationHelper.vue';

const STATUS_OPEN = 1;
const STATUS_SUBMITTED = 2;
const STATUS_FINALIZED = 3;
const STATUS_CANCELLED = 4;

const STATUS_OPTIONS = [
    { value: '', label: 'كل الحالات' },
    { value: STATUS_OPEN, label: 'مفتوح' },
    { value: STATUS_SUBMITTED, label: 'مرسل للمراجعة' },
    { value: STATUS_FINALIZED, label: 'مرحّل' },
    { value: STATUS_CANCELLED, label: 'ملغي' },
];

export default {
    name: 'InventoryCount',
    mixins: [HelperMixin],
    components: { PaginationHelper },

    async created() {
        await this.CheckLoginStatus();
        if (!this.loginDetails || !this.canViewPage) {
            this.$helper.ShowMessage('error', 'غير مصرح', 'ليس لديك صلاحية للوصول إلى واجهة الجرد والتسويات');
            this.href('/Home');
            return;
        }

        await this.loadStockings();
        await this.GetStatistics();
        await this.GetInfo(1);
    },

    computed: {
        canViewPage() {
            return !!(this.loginDetails && this.canViewInventoryCountsUi());
        },
        canCreatePage() {
            return this.canCreateInventoryCountsUi();
        },
        statusOptions() {
            return STATUS_OPTIONS;
        },
        statsCards() {
            const s = this.statistics || {};
            return [
                this.statCard('جردات مفتوحة', s.open, 'primary', 'ti ti-lock-open', 'بانتظار إدخال الكميات'),
                this.statCard('تحت المراجعة', s.submitted, 'warning', 'ti ti-clock', 'بانتظار اعتماد المدير'),
                this.statCard('جردات مرحّلة', s.finalized, 'success', 'ti ti-circle-check', 'مرحّلة ومكتملة'),
                this.statCard('جردات ملغية', s.cancelled, 'danger', 'ti ti-circle-x', 'تم إلغاؤها'),
            ];
        },
    },

    filters: {
        moment(date) {
            if (!date) return '—';
            return moment(date).format('DD/MM/YYYY HH:mm');
        },
        momentDate(date) {
            if (!date) return '—';
            return moment(date).format('DD/MM/YYYY');
        },
    },

    data() {
        return {
            filters: {
                pageNo: 1,
                pageSize: 25,
                stockingId: null,
                status: '',
                from: null,
                to: null,
                search: '',
            },
            Info: [],
            pages: 0,
            loadingList: false,
            statistics: {},

            stockingList: [],

            createDialog: false,
            createForm: {
                StockingId: null,
                Note: '',
            },
            createRules: {
                StockingId: [
                    { required: true, message: 'الرجاء اختيار المخزن', trigger: 'change' },
                ],
            },
        };
    },

    methods: {
        tableRowNumber(index) {
            const pn = Number(this.filters.pageNo || 1);
            const ps = Number(this.filters.pageSize || 25);
            return (pn - 1) * ps + index + 1;
        },

        statusBadgeClass(badge) {
            return 'inventory-status-badge inventory-status-badge--' + (badge || 'secondary');
        },

        async loadStockings() {
            try {
                const res = await this.$http.GetAllStocking();
                let list = (res && res.data && res.data.info) || [];
                if (this.isFacilityCenterRole() && this.loginDetails && this.loginDetails.branchesId) {
                    list = list.filter((x) => x.branchesId === this.loginDetails.branchesId);
                }
                this.stockingList = list;
            } catch (e) {
                this.stockingList = [];
            }
        },

        GetStatistics() {
            return this.$http.GetInventoryCountStatistics()
                .then((res) => { this.statistics = (res && res.data) || {}; })
                .catch(() => { this.statistics = {}; });
        },

        queryFilters(includePaging) {
            const q = {
                stockingId: this.filters.stockingId || null,
                status: this.filters.status === '' ? null : this.filters.status,
                from: this.filters.from || null,
                to: this.filters.to || null,
                search: (this.filters.search || '').trim() || null,
            };
            if (includePaging) {
                q.pageNo = this.filters.pageNo;
                q.pageSize = this.filters.pageSize;
            }
            return q;
        },

        GetInfo(pageNo) {
            this.filters.pageNo = pageNo || 1;
            this.loadingList = true;
            this.$blockUI.Start();
            this.$http.GetInventoryCountList(this.queryFilters(true))
                .then((res) => {
                    this.$blockUI.Stop();
                    this.loadingList = false;
                    this.Info = (res && res.data && res.data.info) || [];
                    this.pages = (res && res.data && res.data.count) || 0;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                    this.loadingList = false;
                    this.Info = [];
                    this.pages = 0;
                });
        },

        ApplyFilters() {
            this.GetInfo(1);
            this.GetStatistics();
        },

        ResetFilters() {
            this.filters.search = '';
            this.filters.stockingId = null;
            this.filters.status = '';
            this.filters.from = null;
            this.filters.to = null;
            this.filters.pageSize = 25;
            this.ApplyFilters();
        },

        OpenCreateDialog() {
            if (!this.canCreatePage) {
                this.$helper.ShowMessage('warning', 'غير مسموح', 'ليس لديك صلاحية فتح جرد جديد.');
                return;
            }
            this.createForm = { StockingId: null, Note: '' };
            this.createDialog = true;
        },

        SubmitCreateForm() {
            this.$refs.createForm.validate((valid) => {
                if (!valid) return;
                const payload = {
                    StockingId: Number(this.createForm.StockingId),
                    Note: this.createForm.Note || null,
                };
                this.$blockUI.Start();
                this.$http.CreateInventoryCountSession(payload)
                    .then((res) => {
                        this.$blockUI.Stop();
                        const data = (res && res.data) || {};
                        this.$helper.ShowMessage('success', 'تم فتح الجرد', data.message || 'تم فتح جلسة الجرد بنجاح.');
                        this.createDialog = false;
                        this.GetStatistics();
                        this.GetInfo(1);
                        if (data.id) {
                            this.$router.push({ name: 'InventoryCountDetails', params: { id: data.id } });
                        }
                    })
                    .catch((err) => {
                        this.$blockUI.Stop();
                        const msg = err && err.response && err.response.data ? err.response.data : 'تعذّر فتح الجرد.';
                        this.$helper.ShowMessage('error', 'خطأ', msg);
                    });
            });
        },

        goToDetails(row) {
            if (!row || !row.id) return;
            this.$router.push({ name: 'InventoryCountDetails', params: { id: row.id } });
        },

        PrintSession(row) {
            const id = row && row.id;
            if (!id) return;
            const url = this.$http.GetInventoryCountPrintUrl(id);
            const w = window.open(url, '_blank');
            if (!w) {
                this.$helper.ShowMessage('warning', 'النوافذ المنبثقة محجوبة', 'الرجاء السماح بالنوافذ المنبثقة لاستعراض تقرير الجرد.');
            }
        },
    },
};
